import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupIntersect3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBooleanGroupIntersect3"><Path d="M12 8H16V12H14V10H12V8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8 2H22V16H16V22H2V8H8V2ZM10 14H20V4H10V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupIntersect3;
